/**
 * Created by mac on 12/23/20
 */

const Chest = function (unit) {
    UnitComponent.call(this, unit);

    cleverapps.missionManager.on("add", (mission) => this.onMissionUpdate(mission), this);
    cleverapps.missionManager.on("complete", (mission) => this.onMissionUpdate(mission), this);
};

Chest.prototype = Object.create(UnitComponent.prototype);
Chest.prototype.constructor = Chest;

Chest.prototype.onMissionUpdate = function (mission) {
    if (typeof ChestTime !== "undefined" && mission.logic instanceof ChestTime) {
        this.onUpdateState();
    }
};

Chest.prototype.openAnimation = function () {
    if (this.view) {
        this.view.openChest();
    }
};

Chest.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

Chest.prototype.open = function () {
    if (!this.checkFreeSpaceToOpen()) {
        return;
    }

    let prizes = this.listPrize();

    Map2d.mapEvent(Map2d.PRIZE_HARVESTED, { affected: this.unit, prizes });

    if (this.extraPrizes) {
        prizes = this.extraPrizes.concat(prizes);
    }

    const options = {
        radius: this.unit.getData().radius !== undefined ? this.unit.getData().radius : Map2d.RADIUS_BIG,
        skipCheckScreen: this.unit.getData().skipCheckScreen,
        spawnSource: "chest"
    };

    if (cleverapps.gameModes.fastSpawnPrizes) {
        options.skipCheckScreen = true;
    }

    this.openAnimation();
    this.unit.remove(true);

    Map2dLocation.currentLocation.spawn(prizes, this.unit, options);
};

Chest.prototype.checkFreeSpaceToOpen = function () {
    const merge = Map2dLocation.currentLocation;
    const prizes = this.listPrize();
    const left = prizes.length + (this.extraPrizes ? this.extraPrizes.length : 0) - merge.map.countEmptySlots() - 1;
    if (left <= 0) {
        return true;
    }
    cleverapps.metrics.logEvent(cleverapps.EVENTS.NO_SPACE);
    const mergeblUnit = merge.map.hasMergeable();
    if (mergeblUnit) {
        this.hintToFreeSpace(mergeblUnit, left);
        return false;
    }
    const units = merge.map.listAvailableUnits();
    for (let i = 0; i < units.length; i++) {
        const unit = units[i];
        const info = unit.getActionInfo();
        const collectible = unit.findComponent(Collectible);
        const canBeSold = info && info.buttons && info.buttons.sell;
        if (collectible || canBeSold) {
            this.hintToFreeSpace(unit, left);
            return false;
        }
    }

    cleverapps.focusManager.distract({
        focus: "NotEnoughSpaceWindow",
        action: function (f) {
            new NotEnoughSpaceWindow(this.unit);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });
    return false;
};

Chest.prototype.hintToFreeSpace = function (unit, left) {
    const merge = Map2dLocation.currentLocation;
    merge.map.focusOnUnit(unit, {
        allowScrollWithFocus: true,
        callback: function () {
            cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace.try_to_free", { left }));
            FingerView.hintTap(unit, { runOnce: true });
        }
    });
};

Chest.prototype.calcSellPrice = function () {
    let result = 0;
    this.listPrize().forEach((unit) => {
        let price;
        if (unit.code === "coins") {
            price = Families[unit.code].units[unit.stage].value * 0.5;
        } else if (unit.code === "rubies") {
            price = Families[unit.code].units[unit.stage].value * 1.7;
        } else {
            price = Unit.CalcSellPrice(unit);
        }
        result += price;
    });
    return Math.ceil(result);
};

Chest.GeneratePrizes = function (chest) {
    const prizes = Chest.GetPrizesConfig(chest);
    const res = [];

    const addPrize = function (code, stage, family, hero) {
        const calculated = Chest.GetFamilyProb(code, family, hero, stage);
        
        if (!calculated) {
            return;
        }

        const { codes, probabilities } = calculated;
        code = codes[PseudoRandom.GET().pickOne(probabilities)];

        if (!code) {
            return;
        }
        
        if (hero && stage >= Families[code].units.length - 1) {
            return;
        }

        if (hero && Map2dLocation.currentLocation.location.locationConfig.isMain && cleverapps.gameLevel.getLevel() < 3) {
            return;
        }

        res.push(Prizes.decreasePrizeStageIfNeeded({
            code,
            stage
        }));
    };

    for (const code in prizes) {
        const prize = prizes[code];
        const types = [];
        let amountStages = 0;
        for (let stage = 0; stage < prize.basic.length; stage++) {
            if (prize.basic[stage] >= 0) {
                amountStages++;
            }
        }
        for (let stage = 0; stage < prize.basic.length; stage++) {
            if (prize.basic[stage] >= 0) {
                for (let i = 0; i < prize.basic[stage]; i++) {
                    addPrize(code, stage, prize.family, prize.hero);
                }
                types.push({
                    code,
                    stage,
                    family: prize.family,
                    hero: prize.hero,
                    prob: prize.itemsProb ? prize.itemsProb[stage] : 1 / amountStages
                });
            }
        }
        if (prize.bonus) {
            const amount = PseudoRandom.GET().random(prize.bonus[0], prize.bonus[1]);
            for (let i = 0; i < amount; i++) {
                if (prize.prob) {
                    if (PseudoRandom.GET().nextDouble() > prize.prob) {
                        continue;
                    }
                }
                const p = PseudoRandom.GET().nextDouble();
                let sum = 0;
                for (let v = 0; v < types.length; v++) {
                    sum += types[v].prob;
                    if (sum >= p) {
                        addPrize(types[v].code, types[v].stage, types[v].family, types[v].hero);
                        break;
                    }
                }
            }
        }
    }

    return res;
};

Chest.GetFamilyProb = function (code, family, hero) {
    let codes = [code];
    let openPenalty = 1;

    if (family) {
        codes = cleverapps.unitsLibrary.listAvailableByType(code);
        openPenalty = family.openPenalty !== undefined ? family.openPenalty : 1;
        if (!codes.length) {
            return null;
        }
    }

    if (hero) {
        codes = cleverapps.unitsLibrary.listUnopenedHeroes(hero);
        codes = codes.filter((code) => Families[code].units.length > 1);
        if (codes.length === 0) {
            return null;
        }
    }

    const probabilities = cleverapps.normalize(codes.map((code) => {
        if (!Families[code]) {
            cleverapps.throwAsync(`GetFamilyProb wrong code - ${code}`);
            return 1;
        }

        if (Families[code].probability !== undefined) {
            return Families[code].probability;
        }

        const isComplete = cleverapps.unitsLibrary.getLastOpenStage(code) === Families[code].units.length - 1;
        return isComplete ? openPenalty : 1;
    }));

    return { codes, probabilities };
};

Chest.ListPrizeProb = function (chest) {
    if (cleverapps.flags.fixedChests) {
        if (chest instanceof Unit) {
            chest.seedRandom();
        } else {
            cleverapps.throwAsync("chest is not a unit");
        }

        const prizes = Chest.GeneratePrizes(chest);

        const counts = prizes.reduce((acc, prize) => {
            const key = `${prize.code}_${prize.stage}`;
            acc[key] = acc[key] || { code: prize.code, stage: prize.stage, amount: 0 };
            acc[key].amount++;
            return acc;
        }, {});

        const amount = Object.values(counts).reduce((acc, { amount }) => acc + amount, 0);
        const types = Object.values(counts).sort((a, b) => b.amount - a.amount);
        
        return {
            minAmount: amount,
            maxAmount: amount,
            types
        };
    }
    
    const prizes = Chest.GetPrizesConfig(chest);
    let res = {}, code;

    // eslint-disable-next-line no-shadow
    const addTypes = function (code, stage, family, hero, prob, basic) {
        const calculated = Chest.GetFamilyProb(code, family, hero, stage);
        
        if (!calculated) {
            return false;
        }

        const { codes, probabilities } = calculated;

        for (let i = 0; i < codes.length; i++) {
            res[code].types.push({
                code: codes[i],
                stage: Math.min(stage, Families[codes[i]].units.length - 1),
                prob: probabilities[i] * prob,
                basic: probabilities[i] * basic
            });
        }

        return true;
    };

    let basicTotal = 0;
    for (code in prizes) {
        let amountStages = 0;

        res[code] = {
            minAmount: 0,
            maxAmount: 0,
            resource: prizes[code].resource,
            types: []
        };

        for (let stage = 0; stage < prizes[code].basic.length; stage++) {
            if (prizes[code].basic[stage] >= 0) {
                amountStages++;
            }
        }
        for (let stage = 0; stage < prizes[code].basic.length; stage++) {
            if (prizes[code].basic[stage] >= 0) {
                res[code].minAmount += prizes[code].basic[stage];
                res[code].maxAmount += prizes[code].basic[stage];
                if (addTypes(code, stage, prizes[code].family, prizes[code].hero, prizes[code].itemsProb ? prizes[code].itemsProb[stage] : 1 / amountStages, prizes[code].basic[stage])) {
                    basicTotal += prizes[code].basic[stage];
                }
            }
        }
        if (prizes[code].bonus) {
            if (!prizes[code].prob) {
                res[code].minAmount += prizes[code].bonus[0];
            }
            res[code].maxAmount += prizes[code].bonus[1];
        }

        if (!res[code].types.length || !res[code].maxAmount) {
            delete res[code];
        }
    }

    const total = {
        minAmount: 0,
        maxAmount: 0,
        types: []
    };

    for (code in res) {
        total.minAmount += res[code].minAmount;
        total.maxAmount += res[code].maxAmount;
    }

    const med = (total.minAmount + total.maxAmount) / 2;
    let i;

    const notBasicProb = 1 - basicTotal / med;

    for (code in res) {
        const cur = (res[code].minAmount + res[code].maxAmount) / 2;
        for (i = 0; i < res[code].types.length; i++) {
            const type = res[code].types[i];
            total.types.push(type);
            type.prob = (type.prob * cur / med) * notBasicProb + (basicTotal ? (type.basic / basicTotal) * (1 - notBasicProb) : 0);
        }
    }

    let probSum = 0;
    for (i = 0; i < total.types.length - 1; i++) {
        if (probSum + total.types[i].prob >= 1) {
            total.types = total.types.slice(0, i + 1);
            break;
        }
        probSum += total.types[i].prob;
    }
    total.types[total.types.length - 1].prob = 1 - probSum;

    for (i = 0; i < total.types.length; i++) {
        total.types[i].prob = Math.round(total.types[i].prob * 10000) / 100;
    }

    let order = [];
    for (i = 0; i < total.types.length; i++) {
        order.push(i);
    }

    order = order.sort((a, b) => {
        if (total.types[b].prob !== total.types[a].prob) {
            return total.types[b].prob - total.types[a].prob;
        }
        return a - b;
    });

    res = {
        minAmount: total.minAmount,
        maxAmount: total.maxAmount,
        types: []
    };

    for (i = 0; i < order.length; i++) {
        res.types.push(total.types[order[i]]);
    }

    return res;
};

Chest.GetPrizesConfig = function (chest) {
    const prizes = cleverapps.clone(ChestListPrize[chest.code][chest.stage], true);

    for (const key in prizes) {
        if (prizes[key].hero) {
            const heroCode = cleverapps.unitsLibrary.getCurrentHero(prizes[key].hero);
            if (!heroCode) {
                Object.assign(prizes, prizes[key].noHeroes || {});
                delete prizes[key];
            }
        }
    }

    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (!locationConfig.usesEnergy) {
        delete prizes.energy;
    }

    return prizes;
};

Chest.prototype.listPrize = function () {
    this.unit.seedRandom();
    return Chest.GeneratePrizes(this.unit);
};

Chest.prototype.handleClick = function () {
    const animateClick = () => {
        this.unit.squeeze();
        cleverapps.effects.fire("meta.coins.collect");
    };

    if (cleverapps.gameModes.skipOpenChestWindow) {
        animateClick();
        this.open();
        return true;
    }

    cleverapps.focusManager.display({
        stack: Map2dLocation.currentLocation.tutorial.checkConditions({ unit: this.unit, advice: [Map2d.OPENCHEST, Map2d.CLICK_UNIT, Map2d.SPAWN] })
            || cleverapps.tutorial.checkConditions({ unit: this.unit, advice: [Map2d.OPENCHEST, Map2d.CLICK_UNIT, Map2d.SPAWN] }),
        focus: "openChestWindow",
        actions: [
            (f) => {
                animateClick();

                cleverapps.timeouts.setTimeout(f, 300);
            },

            (f) => {
                new OpenChestWindow(this);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        ]
    });

    return true;
};

Chest.prototype.getEnergyAmount = function () {
    return this.unit.getData().energyPrize;
};

Chest.prototype.isEnergyAvailable = function () {
    if (this.unit.isLockedUnit()) {
        return false;
    }

    const mission = cleverapps.missionManager.findByType(Mission.TYPE_CHESTTIME);
    return (Chest.AlwaysWithEnergy(this.unit) || mission && mission.isRunning()) && this.getEnergyAmount();
};

Chest.AlwaysWithEnergy = function (unit) {
    return unit.code === "dailytaskchest";
};

Chest.prototype.setExtraPrizes = function (prizes) {
    if (prizes) {
        this.extraPrizes = cleverapps.toArray(prizes);
    } else {
        this.extraPrizes = undefined;
    }
};

Chest.prototype.lockStateUpdate = function () {
    this.onUpdateState();
};

Chest.classifyEnergy = function (amount) {
    if (amount > 15) {
        return 3;
    } if (amount > 5) {
        return 2;
    }
    return 1;
};